<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start align-items-center">
            <h1 class="mx-1 d-flex align-items-center">
                <span>
                    Info cerere <span *ngIf="cerere?.reg_numar || cerere?.reg_date">{{cerere?.reg_numar || 'N/A' }} / {{
                        cerere?.reg_date || 'N/A' }}</span>
                </span>
                <span class="text-secondary m-2">#{{ cerere?.id_cerere }}</span>
                <button type="button" class="btn btn-small btn-primary me-3" (click)="getRequestInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span> Reîncarcă informații</span>
                </button>
                <h4 class="m-0" [ngStyle]="{'color': cerere?.source_data?.color}"
                    style="font-weight: 700; text-transform: uppercase;">{{ cerere?.source_data?.name }}</h4>
            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="row p-3 responsive-content">
    <div class="col-8">
        <mat-card>
            <app-subsemnat *ngIf="cerere" [cerere]="cerere"></app-subsemnat>

            <app-document-uat *ngIf="cerere?.id_cerere_type == 6 || cerere?.id_cerere_type == 23" [cerere]="cerere!"
                (cerereChanged)="onCerereChanged($event)" (istoricUpdated)="getIstoric(false)"></app-document-uat>

            <app-documente-generate *ngIf="cerere && slugsForDocGenerate.includes(cerere.cerere_type_slug)"
                [cerere]="cerere!" (requestInfoUpdated)="getRequestInfo()"></app-documente-generate>

            <div class="g-0" *ngIf="cerere?.autovehicule !== null && cerere?.autovehicule?.length !== 0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header box-content-header-documents">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-solid fa-folder-tree"></i>
                                        <span>Autovehicule - Taxa specială pentru dezvoltare urbană</span>
                                    </mat-card-title>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="p-3">
                                <div class="col d-flex justify-content-start p-2">
                                    <table class="table table-condensed table-wrapper-box w-100">
                                        <thead>
                                            <tr>
                                                <th class="text-right" width="10%">Crt.</th>
                                                <th>Număr Înmatriculare</th>
                                                <th>Serie Șasiu</th>
                                                <th
                                                    *ngIf="cerere?.cerere_type_slug === 'tsdu_scutire_parcare_privata_utilizator_pf' || 
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_privata_utilizator_pj' || 
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_proprietate_personala_pf' ||
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_proprietate_personala_pj'">
                                                    Număr cadastral
                                                </th>
                                                <th width="40%">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let autovehicul of cerere?.autovehicule; let i = index">
                                                <td class="text-right">{{ i + 1 }}</td>
                                                <td>{{ autovehicul.numar_inmatriculare }}</td>
                                                <td>{{ autovehicul.serie_sasiu }}</td>
                                                <td
                                                    *ngIf="cerere?.cerere_type_slug === 'tsdu_scutire_parcare_privata_utilizator_pf' || 
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_privata_utilizator_pj' || 
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_proprietate_personala_pf' ||
                                                           cerere?.cerere_type_slug === 'tsdu_scutire_parcare_proprietate_personala_pj'">
                                                    {{ autovehicul.numar_cadastral || 'n/a' }}
                                                </td>
                                                <td>...</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-documents">
                        <div class="box-content-header box-content-header-documents">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-solid fa-folder-tree"></i>
                                        <span>Documente</span>
                                    </mat-card-title>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="p-3">
                                <div class="request-filter-container">
                                    <div class="request-filter">
                                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                            [value]="getDocumentTypeKeys()[0]">
                                            <mat-button-toggle *ngFor="let docTypeKey of getDocumentTypeKeys()"
                                                [value]="docTypeKey" (change)="onDocumentChange($event)">
                                                {{ cerere?.documente?.[docTypeKey]?.name }}
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                                <div class="p-2">
                                    <mat-divider></mat-divider>
                                </div>
                                <div class="docs d-flex flex-row justify-content-start align-items-center flex-wrap">
                                    <button type="button" class="btn btn-light upload-btn m-2"
                                        *ngFor="let file of cerere?.documente?.[selectedDocTypeKey]?.items"
                                        (click)="downloadDocument(file)">
                                        <span class="upload__text">
                                            <img src="assets/icons/icon-download-blue.svg" alt="Descarcă" />
                                            &nbsp;{{ file.old_name }}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-mesagerie">
                        <div class="box-content-header box-content-header-mesagerie">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-brands fa-rocketchat"></i>
                                        <span>Mesagerie</span>
                                    </mat-card-title>
                                </div>
                                <div class="col d-flex justify-content-end">
                                    <div>
                                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                            (change)="onMessagingChange($event)" value="internalMsg">
                                            <mat-button-toggle value="toCetatean">Către Cetățean</mat-button-toggle>
                                            <mat-button-toggle value="internalMsg">Mesaj Intern</mat-button-toggle>
                                            <mat-button-toggle value="nota">Notă</mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="row p-2" *ngIf="selectedMessagingToggle == 'toCetatean'">
                                <div class="col">
                                    <div class="fw-bold">Transmiteți un mesaj către cetățean</div>
                                </div>
                            </div>
                            <div class="row p-2" *ngIf="selectedMessagingToggle == 'internalMsg'">
                                <div class="col">
                                    <div class="fw-bold">Adăugați un mesaj</div>
                                </div>
                            </div>
                            <div class="row p-2" *ngIf="selectedMessagingToggle == 'nota'">
                                <div class="col">
                                    <div class="fw-bold">Adăugați o notă</div>
                                </div>
                            </div>

                            <form [formGroup]="sendMessageCetateanForm" (ngSubmit)="submitMessage('cetatean')"
                                *ngIf="selectedMessagingToggle == 'toCetatean'">
                                <div class="row">
                                    <div class="col">
                                        <angular-editor formControlName="message"
                                            [config]="editorConfig"></angular-editor>
                                        <mat-error
                                            *ngIf="sendMessageCetateanForm.get('message')?.touched && sendMessageCetateanForm.get('message')?.invalid">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </div>
                                </div>

                                <div class="solicitare-card__upload mx-2 mt-3">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Fotografii/Documente</p>
                                        <button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                            ÎNCARCĂ
                                        </button>
                                    </div>
                                    <div class="solicitare-card__upload-files" *ngIf="
                                        sendMessageCetateanForm.value.files.length > 0 &&
                                        !uploading.file
                                        ">
                                        <div class="solicitare-card__upload-file" *ngFor="
                                            let uploadedFile of sendMessageCetateanForm.value.files;
                                            let i = index
                                        ">
                                            <span class="solicitare-card__upload-file-name">
                                                {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                                | slice : 0 : 30) + ".." : uploadedFile.original_name
                                                }}
                                            </span>
                                            <div>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul încărcat"
                                                    (click)="removeFileCetatean(i)">
                                                    <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                        *ngIf="uploading.file"></mat-spinner>

                                    <input type="file"
                                        accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                        id="upload-file-input-0" #fileInputCetatean name="fileInputCetatean"
                                        (change)="addFileCetatean($event, 'file')" multiple style="display: none" />
                                </div>

                                <div class="row my-3">
                                    <div class="col d-flex align-items-center">
                                        <mat-checkbox style="margin-right: 30px;" formControlName="notify"
                                            color="primary">Notificare răspuns
                                        </mat-checkbox>
                                        <form [formGroup]="notifyAnswer" style="width: 30%;">
                                            <ng-container *ngIf="sendMessageCetateanForm.get('notify')?.value">
                                                <mat-form-field class="mt-3">
                                                    <mat-label>Număr zile</mat-label>
                                                    <mat-select formControlName="notify_date_expire">
                                                        <mat-option *ngFor="let response of responseTimes"
                                                            [value]="response.value">
                                                            {{ response.key }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="notifyAnswer.get('notify_date_expire')?.touched && 
													notifyAnswer.get('notify_date_expire')?.hasError('required')">
                                                        Câmp obligatoriu
                                                    </mat-error>
                                                </mat-form-field>
                                            </ng-container>
                                        </form>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col d-flex justify-content-between">
                                        <div class="p-1">
                                            <button class="btn btn-light upload-btn" type="button"
                                                (click)="openSabloane()">
                                                <span class="upload__text">Șabloane</span>
                                            </button>
                                        </div>

                                        <div class="p-1">
                                            <button class="btn btn-light upload-btn" type="submit"
                                                [disabled]="sendMessageCetateanForm.invalid">
                                                <span class="upload__text">TRIMITE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <form [formGroup]="sendMessageInternForm" (ngSubmit)="submitMessage('intern')"
                                *ngIf="selectedMessagingToggle == 'internalMsg'">
                                <div class="row">
                                    <div class="col">
                                        <angular-editor formControlName="message"
                                            [config]="editorConfig"></angular-editor>
                                        <mat-error
                                            *ngIf="sendMessageInternForm.get('message')?.touched && sendMessageInternForm.get('message')?.invalid">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </div>
                                </div>

                                <div class="row p-1">
                                    <div class="col">
                                        <mat-form-field class="w-100">
                                            <mat-label>Adaugă coleg</mat-label>
                                            <mat-chip-grid #chipGrid aria-label="Selectare colegi">
                                                <mat-chip-row *ngFor="let coleague of coleagues"
                                                    (removed)="removeColeague(coleague)">
                                                    {{coleague.name}}
                                                    <button matChipRemove [attr.aria-label]="'remove ' + coleague.name">
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip-row>
                                            </mat-chip-grid>
                                            <input placeholder="Coleg nou..." #coleagueInput
                                                [formControl]="coleaguesCtrl" [matChipInputFor]="chipGrid"
                                                [matAutocomplete]="auto"
                                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                (matChipInputTokenEnd)="addColeague($event)" />
                                            <mat-autocomplete #auto="matAutocomplete"
                                                (optionSelected)="selectedColeagues($event)">
                                                <mat-option *ngFor="let coleague of filteredColeagues | async"
                                                    [value]="coleague">
                                                    {{coleague.name}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="solicitare-card__upload mx-2">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Fotografii/Documente</p>
                                        <button class="upload-btn" (click)="fileInputIntern.click()" type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                            ÎNCARCĂ
                                        </button>
                                    </div>
                                    <div class="solicitare-card__upload-files"
                                        *ngIf="sendMessageInternForm.value.files && sendMessageInternForm.value.files.length > 0 && !uploading.file">
                                        <div class="solicitare-card__upload-file" *ngFor="
                                                let uploadedFile of sendMessageInternForm.value.files;
                                                let i = index
                                            ">
                                            <span class="solicitare-card__upload-file-name">
                                                {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                                | slice : 0 : 30) + ".." : uploadedFile.original_name
                                                }}
                                            </span>
                                            <div>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul încărcat" (click)="removeFileIntern(i)">
                                                    <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                        *ngIf="uploading.file"></mat-spinner>

                                    <input type="file"
                                        accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                        id="upload-file-input-0" #fileInputIntern name="fileInputIntern"
                                        (change)="addFileIntern($event, 'file')" multiple style="display: none" />
                                </div>

                                <div class="col d-flex justify-content-end">
                                    <button class="btn btn-light upload-btn m-3" type="submit"
                                        [disabled]="sendMessageInternForm.invalid">
                                        <span class="upload__text">TRIMITE</span>
                                    </button>
                                </div>
                            </form>

                            <form [formGroup]="sendMessageNotitaForm" (ngSubmit)="submitMessage('nota')"
                                *ngIf="selectedMessagingToggle == 'nota'">
                                <div class="row">
                                    <div class="col">
                                        <angular-editor formControlName="message"
                                            [config]="editorConfig"></angular-editor>
                                        <mat-error
                                            *ngIf="sendMessageNotitaForm.get('message')?.touched && sendMessageNotitaForm.get('message')?.invalid">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </div>
                                </div>

                                <div class="solicitare-card__upload mx-2 mt-3">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Fotografii/Documente</p>
                                        <button class="upload-btn" (click)="fileInputNotita.click()" type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                            ÎNCARCĂ
                                        </button>
                                    </div>
                                    <div class="solicitare-card__upload-files" *ngIf="
                                        sendMessageNotitaForm.value.files.length > 0 &&
                                        !uploading.file
                                        ">
                                        <div class="solicitare-card__upload-file" *ngFor="
                                            let uploadedFile of sendMessageNotitaForm.value.files;
                                            let i = index
                                        ">
                                            <span class="solicitare-card__upload-file-name">
                                                {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                                | slice : 0 : 30) + ".." : uploadedFile.original_name
                                                }}
                                            </span>
                                            <div>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul încărcat" (click)="removeFileNota(i)">
                                                    <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                        *ngIf="uploading.file"></mat-spinner>

                                    <input type="file"
                                        accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                        id="upload-file-input-0" #fileInputNotita name="fileInputNotita"
                                        (change)="addFileNotita($event, 'file')" multiple style="display: none" />
                                </div>

                                <div class="col d-flex justify-content-end">
                                    <button class="btn btn-light upload-btn m-3" type="submit"
                                        [disabled]="sendMessageNotitaForm.invalid">
                                        <span class="upload__text">TRIMITE</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <app-cereri-istoric *ngIf="cerere" [istoric]="this.istoric" [user]="user" [id_cerere]="cerere.id_cerere"
                [notifyIds]="cerere.historyNotify" (requestInfoUpdated)="getRequestInfo()"
                (isLoading)="onIsLoadingChange($event)">
            </app-cereri-istoric>
        </mat-card>
    </div>
    <div class="col-4">
        <mat-card>
            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-infoCerere">
                        <div class="box-content-header box-content-header-infoCerere">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-solid fa-circle-info"></i>
                                        <span>Info cerere</span>
                                    </mat-card-title>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <table class="table table-condensed table-wrapper-box">
                                <tbody>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Tip</strong>
                                        </td>
                                        <td class="text-left">{{ cerere?.cerere_type?.name }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Categorie</strong>
                                        </td>
                                        <td class="text-left">{{ cerere?.compartiment_denumire }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Prioritate</strong>
                                        </td>
                                        <td class="text-left">
                                            <span class="badge"
                                                [ngStyle]="{'background-color': cerere?.priority?.color, color: cerere?.priority?.bgColor}">
                                                {{ cerere?.priority?.name }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Status</strong>
                                        </td>
                                        <td class="text-left">
                                            <span class="badge"
                                                [ngStyle]="{'background-color': cerere?.current_status?.color, color: cerere?.current_status?.bgColor}">
                                                {{ cerere?.current_status?.name }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Email cetățean</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ cerere?.cetatean?.email || 'n/a' }}
                                            <i *ngIf="permissionsService.hasPermission('dgitl-module.solicitari.view.update-citizen-email')"
                                                style="cursor: pointer;" class="fa fa-pencil text-warning"
                                                (click)="openEditDialog(cerere?.cetatean?.email)">
                                            </i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Departament</strong>
                                        </td>
                                        <td class="text-left">
                                            {{ cerere?.compartiment_denumire_assigned || "n/a" }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Ticket asignat</strong>
                                        </td>
                                        <td class="text-left">{{ cerere?.asigned_user?.name || 'n/a' }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Dată creat</strong>
                                        </td>
                                        <td class="text-left">{{ cerere?.created_at | date:'dd.MM.yyyy HH:mm' }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Dată actualizat</strong>
                                        </td>
                                        <td class="text-left">{{ cerere?.updated_at | date:'dd.MM.yyyy HH:mm' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="g-0">
                <div class="col">
                    <div class="box-wrapper box-actiuni">
                        <div class="box-content-header box-content-header-actiuni">
                            <div class="row p-1">
                                <div class="col">
                                    <mat-card-title>
                                        <i class="fa-solid fa-shuffle"></i>
                                        <span>Acțiuni cerere</span>
                                    </mat-card-title>
                                </div>
                            </div>
                        </div>
                        <div class="box-content-body">
                            <div class="row p-2 d-flex">
                                <div class="w-auto"
                                    *ngIf="cerere?.asigned_user == null || cerere?.asigned_user?.id_user !== user.id_user">
                                    <button class="btn btn-light upload-btn" type="button"
                                        (click)="confirmPreluarePersonala()">
                                        <span class="upload__text">PRELUARE PERSONALĂ</span>
                                    </button>
                                </div>

                                <div class="w-auto" *ngIf="showPreluareNumarRegistratura()">
                                    <button class="btn btn-light upload-btn" type="button"
                                        (click)="confirmPreluareNumarRegistratura()">
                                        <span class="upload__text">PRELUARE NUMĂR REGISTRATURĂ</span>
                                    </button>
                                </div>

                            </div>
                            <div class="row p-2 d-flex">
                                <div class="col"
                                    [class.hidden]="cerere?.cancel_type == 1 && cerere?.cancel_date !== null">
                                    <actiuni-cerere-card title="Status validat" description="Nevalidat" iconName="check"
                                        [cerere]="cerere" actionText="Validează" actionType="validate"
                                        (buttonClicked)="handleButtonClick($event)"
                                        (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                </div>
                                <ng-container>

                                    <div class="col" *ngIf="cerere?.validated_date === null && (
                                            (cerere?.cancel_type == null && cerere?.registratura?.finalize_date == null) ||
                                            (cerere?.cancel_type == 1)
                                        )">
                                        <actiuni-cerere-card title="Invalidare Cerere"
                                            description="Cerere încă valabilă de validare. Nu invalidați decât dacă este cazul!"
                                            iconName="report_problem" actionText="Invalidează" [cerere]="cerere"
                                            actionType="invalidate" (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>
                                    <div class="col" *ngIf="(cerere?.validated_date !== null && cerere?.cancel_type == null && cerere?.registratura?.finalize_date == null) ||
                                            cerere?.cancel_type == 2">
                                        <actiuni-cerere-card title="Clasare" description="Clasare"
                                            iconName="report_problem" actionText="Clasare" [cerere]="cerere"
                                            actionType="anulare" (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="
                                        cerere?.cancel_date !== null ||
                                        cerere?.validated_date !== null">
                                    <div class="col">
                                        <actiuni-cerere-card title="Status Închidere Lucrare"
                                            description="Închidere lucrare doar în momentul în care a fost soluționată cererea."
                                            iconName="check" actionText="Închidere lucrare" [cerere]="cerere"
                                            actionType="finalizare" (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-actualizare-cerere *ngIf="cerere?.current_status" [cerere]="cerere!" [directii]="directii"
                [statusCerere]="statusCerere" [prioritateCerere]="prioritateCerere"
                (cerereChanged)="onCerereChanged($event)" (istoricUpdated)="getIstoric(false)"></app-actualizare-cerere>
        </mat-card>
    </div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/images/logo-dgitl4.png" height="150%" width="150%" alt="DGITL4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>